import getPBracketsCDNURL from '@pickleballinc/ui/components/global/utils/getPBracketsCDNURL';
import clsx from 'clsx';
import Link from 'next/link';

import { MLPStripData } from '@/entities/MLPStripData';
import { useOrganizationStore } from '@/store/organization-store';
import { DateUtil } from '@/utils/date';

interface MLPEventCardProps {
	event: MLPStripData;
	className?: string;
}

export const MLPEventCard = ({ event, className = '' }: MLPEventCardProps) => {
	const store = useOrganizationStore();
	const tlTimeZone = store.teamLeagueTimeZone;

	const startDateTime = DateUtil.formatUTCInTimezone(event.startDatetime, 'MMM D, YYYY', tlTimeZone?.ianaTzIdentifier);
	const endDateTime = DateUtil.formatUTCInTimezone(event.endDatetime, 'MMM D, YYYY', tlTimeZone?.ianaTzIdentifier);

	return (
		<Link href={`/team-leagues/${event.teamLeagueSlug}/event/${event.matchupGroupsUuid}`} scroll>
			<div
				className={`relative h-full w-[215px] cursor-pointer overflow-hidden rounded-xl border border-gray-300 } h-fit bg-transparent ${className}`}
			>
				<div
					className={clsx('flex h-[120px] w-full items-center justify-center border-b border-gray-300', {
						'bg-gray-100': !!event.logo?.url,
						'bg-white': !event.logo?.url
					})}
				>
					<img
						src={
							event.logo?.url
								? getPBracketsCDNURL(`${event.logo?.url}`, 300, 150)
								: `https://images.pickleball.com/systemLogos/1739801397388/Major-League-Pickleball.jpg`
						}
						alt="League logo"
						className="mx-auto size-full object-contain"
					/>
				</div>
				<div className="h-fit flex w-full flex-col gap-2 px-4 pb-4 pt-3 transition-colors">
					<h3 className="line-clamp-2 text-sm font-medium leading-5 text-white min-h-8">{event.title}</h3>

					{event.location ? (
						<p className={`text-sm font-normal leading-5 text-gray-200`}>
							{event.location?.city}, {event.location?.stateInfo?.title}, {event.location?.countryInfo?.abbreviation}
						</p>
					) : null}

					{event.startDatetime && event.endDatetime ? (
						<p className="text-xs font-normal leading-[18px] text-gray-50">{`${startDateTime} - ${endDateTime}`}</p>
					) : (
						event.endDatetime && <p className={`text-sm text-white`}>Ended on {endDateTime}</p>
					)}
				</div>
			</div>
		</Link>
	);
};
